export const tableDataSchemas = [
  {
    prop: 'name',
    label: '诊所名',
    minWidth: 120
  },

  {
    prop: 'address',
    label: '地址',
    minWidth: 120
  },
  {
    prop: 'businessTime',
    label: '营业时间',
    minWidth: 80
  },
  {
    prop: 'coordinates',
    label: '经纬度',
    minWidth: 80
  },
  {
    prop: 'tel',
    label: '电话热线',
    minWidth: 80
  }
]
